import * as React from "react";

import { renderMenuButton_unstable } from "@fluentui/react-components";

// eslint-disable-next-line no-restricted-imports
import type { AppMenuButtonProps } from "@1js/acui-button/lib/Next";
// eslint-disable-next-line no-restricted-imports
import { useAppSplitButtonMenuButton } from "@1js/acui-button/lib/Next";
import { useRibbonMenuButtonState } from "../../RibbonFlyoutAnchor/next";
import { useRibbonSplitButtonMenuButtonStyles } from "./useRibbonSplitButtonMenuButtonStyles.styles";
import { useLargeRibbonMenuButtonLabel } from "../../../../../hooks";
import { AppTooltipContainer } from "@1js/acui-tooltip";

export const RibbonSplitButtonMenuButton = React.memo(
  React.forwardRef<HTMLButtonElement, AppMenuButtonProps>((props, ref) => {
    const state = useAppSplitButtonMenuButton(
      {
        ...props,
        children: useLargeRibbonMenuButtonLabel(props),
      },
      ref
    );

    useRibbonMenuButtonState(props, state);

    useRibbonSplitButtonMenuButtonStyles(state);

    return (
      <AppTooltipContainer
        {...props}
        showTooltip={props.showTooltip && state.menuHidden}
      >
        {renderMenuButton_unstable(state)}
      </AppTooltipContainer>
    );
  })
);

RibbonSplitButtonMenuButton.displayName = "next/RibbonSplitButtonMenuButton";
